/* =============================================================
   AUZZI Mobile menu defer hydration (Phase 14)

   Pairs with snippets/header-drawer.liquid which now wraps each
   grandchild <ul> in a <template data-menu-defer-source> inside
   a <ul data-menu-defer-host>. This keeps the deepest level of
   mobile menu HTML OUT of the active document tree until the
   parent <details> is opened by the user.

   Why this matters:
   - <template> content is parsed but inert: no DOM nodes, no
     layout, no paint cost on initial render.
   - On a 60k-product store with ~8 categories × ~10 subcats ×
     ~5 grandchildren that's ~400 anchor tags kept out of the
     main DOM until the user actually needs them.
   - Static HTML view still contains the markup, so SEO crawlers
     and link-discovery tools see every link.

   Design:
   - One-time hydration per <details> first toggle.
   - Idempotent: if called twice, the second call is a no-op
     because the template is removed after hydration.
   - Defensive: skipped entirely if browser lacks <template>
     support (very old browsers — links would render anyway from
     the <template>'s outerHTML fallback path).
   - Honours prefers-reduced-motion implicitly (no animations
     introduced).
   ============================================================= */
(function () {
  'use strict';

  if (!('content' in document.createElement('template'))) return;

  function hydrate(scopeEl) {
    if (!scopeEl || scopeEl.__menuHydrated) return;
    /* Find any <template data-menu-defer-source> nested under this scope —
       handles both patterns:
         - <details>...<ul data-menu-defer-host><template>…</template></ul>
         - <li data-menu-defer-host>…<div><template>…</template></div></li>
       Each template is cloned into its parent node and removed. */
    var templates = scopeEl.querySelectorAll('template[data-menu-defer-source]');
    if (!templates.length) {
      scopeEl.__menuHydrated = true;
      return;
    }
    templates.forEach(function (tpl) {
      var parent = tpl.parentNode;
      if (!parent) return;
      var frag = tpl.content.cloneNode(true);
      parent.insertBefore(frag, tpl);
      tpl.remove();
    });
    scopeEl.__menuHydrated = true;
  }

  /* Bind two hydration patterns:

     1. <details> toggle — for the standard mobile drawer menu loop in
        header-drawer.liquid lines 145-244 (parent.links scheme). Fires
        when user opens a top-level <details>.

     2. [data-menu-defer-host] interaction — for the embedded vertical
        mega-menu blocks in header-drawer.liquid lines 27-141. These
        are <li> elements with a sibling <a> + collapsed mega-menu-content.
        We hydrate on first pointerenter / focusin / touchstart of the
        host so the subcategory cloud is ready by the time the CSS
        :hover/:focus state shows it. */
  function bind() {
    var drawer = document.querySelector('header-drawer, .menu-drawer-container, #menu-drawer');
    var scope = drawer || document;

    /* Pattern 1: <details> */
    var details = scope.querySelectorAll('details');
    details.forEach(function (d) {
      if (!d.querySelector('[data-menu-defer-source]')) return;
      d.addEventListener(
        'toggle',
        function onToggle() {
          if (!d.open) return;
          hydrate(d);
          d.removeEventListener('toggle', onToggle);
        },
        false
      );
    });

    /* Pattern 2: standalone hosts (e.g. <li class="parent-mega-menu"
       data-menu-defer-host>). Hydrate on first hover, focus, or touch
       so the subcategory cloud is in DOM before the user can read it. */
    var hosts = scope.querySelectorAll('[data-menu-defer-host]');
    hosts.forEach(function (h) {
      if (h.__menuHydrated) return;
      var doHydrate = function () {
        hydrate(h);
        h.removeEventListener('pointerenter', doHydrate);
        h.removeEventListener('focusin', doHydrate);
        h.removeEventListener('touchstart', doHydrate);
        h.removeEventListener('click', doHydrate);
      };
      h.addEventListener('pointerenter', doHydrate, { passive: true });
      h.addEventListener('focusin', doHydrate);
      h.addEventListener('touchstart', doHydrate, { passive: true });
      h.addEventListener('click', doHydrate, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
